// extracted by mini-css-extract-plugin
export var cancelled = "EventStatus-module--cancelled--46ff4";
export var live = "EventStatus-module--live--defba";
export var lock = "EventStatus-module--lock--ade1c";
export var pulse = "EventStatus-module--pulse--b618c";
export var pulseAnimation = "EventStatus-module--pulseAnimation--44171";
export var tick = "EventStatus-module--tick--43d54";